import SearchSimple from "../../../../components/SearchSimples/SearchSimple";
import React from "react";
import CustomTable from "../../../../components/table/CustomTable";
import {permissionObj} from "../../../../Helpers/permission";
import {DistributionCenterTableApp} from "../Funtionallity/DistributionCenterTableApp";
import CustomButtonLink from "../../../../components/buttons/CustomButtonLink";
import {useTranslation} from "react-i18next";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const DistributionCenterTable = ({
                                     isAllChecked,
                                     selectedList,
                                     setBodyForExport,
                                     searchElement,
                                     setSearchElement,
                                     optionTable,
                                     setSearch,
                                     simpleSearch,
                                     setSimpleSearch,
                                     results,
                                     setResults,
                                     name,
                                     onClick,
                                     textNoInformation,
                                     setSelectedList,
                                     modified,
                                     setModified,
                                     setIsAllChecked,
                                     setAddShow,
                                     setUpdateData,
                                     setIsUpdate,
                                     setDeleteDistributionCenter
                                 }) => {


    const {DEV, permission, tableId, searchId, thead, tbody, getActionsButtons, handleCheckboxChange, handleDeleteAll,
        pagination, rowsPerPage, contractorId, supplierId, columnActions } = DistributionCenterTableApp({
        selectedList, setSelectedList, setBodyForExport,
        modified, setModified, setIsAllChecked, searchElement, results, setResults,
        setAddShow, setUpdateData, setIsUpdate,
        setDeleteDistributionCenter
    });
    const { t } = useTranslation();

    return(
        <div className={'row mt-4'}>
            <div className={'col-12 p-0'}>
                <SearchSimple
                    id={'txt_cst_search_cards'}
                    setBodyForExport={setBodyForExport}
                    setSearchResults={setResults}
                    searchResults={results}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    optionTable={optionTable}
                    rowsPerPage={rowsPerPage}
                    setSearch={setSearch}
                    simpleSearch={simpleSearch}
                    setSimpleSearch={setSimpleSearch}
                    contractorId={contractorId}
                    supplierId={supplierId}
                />
            </div>

            <div className={'col-12 p-0'}>
                <CustomTable tableId={tableId}
                             searchId={searchId}
                             checkbox={(DEV || permission?.includes(permissionObj?.WEB_DISTRIBUTION_CENTER_DELETE))}
                             checkboxTitle={'de_/_select_all'}
                             isAllChecked={isAllChecked}
                             onChangeCheckbox={handleDeleteAll}
                             thead={thead}
                             tbody={tbody}
                             columnActions={columnActions}
                             getActionsButtons={getActionsButtons}
                             handleCheckboxChange={handleCheckboxChange}
                             selectedList={selectedList}
                             childrenNotInformation={
                                 <>
                                     <div className={'warning-text'}>
                                         <p>{t(textNoInformation)}</p>
                                     </div>
                                     { (DEV || permission?.includes(permissionObj?.WEB_DISTRIBUTION_CENTER_CREATE)) &&
                                         <CustomButtonLink splitName={false} id={'btn_dct_create'}
                                                           onClick={onClick}
                                                           name={name}/>
                                     }
                                 </>
                             }
                />
            </div>

            { pagination() }
        </div>
    )
}

export default DistributionCenterTable;
